import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import EditorjsList from '@editorjs/list';

@Component({
  selector: 'app-mailtemplate-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ModalHeaderComponent,
    LoaderComponent
  ],
  templateUrl: './mailtemplate-form.component.html',
  styleUrl: './mailtemplate-form.component.scss'
})
export class MailtemplateFormComponent implements OnChanges, OnInit {
  @Input() item: any = {};
  @Input() modalInstance: any = null;

  modalTitle: string = 'Mailtemplate';
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  modalStyle: boolean = false;

  editor: any;

  constructor(
    private apiService: ApiService,
    public activeModal: NgbActiveModal
  ) {
    this.item = {};
  }

  ngOnChanges(changes: any) {
    this.loading = true;
    this.item = {};

    this.errorMessage = {};
    this.errors = {};
    this.getItem();
  }

  ngOnInit() {
    this.getItem();
  }

  afterSave() {
    this.activeModal.close(true);
  }

  editorJsToHtml(blocks: any): string {
    if (!blocks || !blocks.blocks || !Array.isArray(blocks.blocks)) return '';

    const renderList = (items: any[], tag: 'ul' | 'ol'): string => {
      return `<${tag}>${items.map(item => {
        const nested = item.items && item.items.length ? renderList(item.items, tag) : '';
        return `<li>${item.content}${nested}</li>`;
      }).join('')}</${tag}>`;
    };

    return blocks.blocks.map((block: any) => {
      switch (block.type) {
        case 'header':
          const level = block.data.level || 1;
          return `<h${level}>${block.data.text}</h${level}>`;

        case 'paragraph':
          return `<p>${block.data.text}</p>`;

        case 'EditorjsList':
          const tag = block.data.style === 'ordered' ? 'ol' : 'ul';
          return renderList(block.data.items, tag);

        default:
          return '';
      }
    }).join('');
  }

  async save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    let method: string = 'put';
    const output = await this.editor.save();
    const html = this.editorJsToHtml(output);

    self.item['content'] = html;

    if (!this.item['id'] || this.item['id'] === '') {
      return this.apiService.post('/office/mail-templates/', this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      return this.apiService.put('/office/mail-templates/' + this.item['id'], this.item).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    self.afterSave();
    setTimeout(function () {
      self.loading = false;
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  async getItem() {
    let itemId = this.item['id'];
    let self = this;

    self.reset();
    if (itemId === '' || itemId === undefined) {
      self.editor = new EditorJS({
        holder: 'editorjs',
        tools: {
          header: Header,
          EditorjsList: EditorjsList
        },
      });
      return;
    }
    return this.apiService.get('/office/mail-templates/' + itemId).then(function async(response: any) {
      self.item = response;
      if (self.item['id']) {
        self.modalTitle = 'Wijzig template';
      } else {
        self.modalTitle = 'Template toevoegen';
      }

      self.editor = new EditorJS({
        holder: 'editorjs',
        tools: {
          header: Header,
          EditorjsList: EditorjsList
        },
        onReady: async () => {
          await self.editor.blocks.renderFromHTML(self.item['content']);
        },
      });

      console.log(self.item['content'])
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
